<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="用户列表"
      width="800px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="user_id" label="用户id"></el-table-column>
      </el-table>
      <el-pagination
        background
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      query: {
        page: 1,
        transaction_url: undefined,//交易链接
        type: undefined,//订单来源
        start_time: undefined,//开始时间
        end_time: undefined,//结束时间
      },
      dataList: undefined,//数据列表
      dataMeta: undefined,//底部分页数据
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    },
    dialogInfo(val) {
      if (val) {
        let location = val.transaction_url.indexOf('=')
        // let location1 = val.transaction_url.indexOf('&')
        this.query.transaction_url = val.transaction_url.slice(location+1)
        if(val.type=='商城'){
          this.query.type = 1
        }else{
          this.query.type = 2          
        }
        this.query.start_time = val.start_time
        this.query.end_time = val.end_time
      }
    }
  },
  created() {
  },
  methods: {
    getData() {
      //获取数据
      this.loading=true
      let params = this.query
      postApiData('extract_transaction_url_user', params).then((res) => {
        this.dataList = res.data
        this.dataMeta=res
      }).finally(() => {
        this.loading=false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData(1);
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>